export const IMPORT_STATUS = [
  { dictKey: '0', dictValue: '已完成' },
  { dictKey: '1', dictValue: '待执行' },
  { dictKey: '2', dictValue: '正在处理' },
  { dictKey: '4', dictValue: '导入失败' },
]
